import './Topic.css'
import DoneIcon from '@mui/icons-material/Done';
const Topic = (props)=>{
    const {text, onClick,image} = props
    return (
        <div onClick={onClick} className='ql-topic-d'>
            <div>{text}</div>
            <div className='ql-topic'>
                <img src={image} />
            </div>
        </div>
    )
}
export default Topic